import { Contact } from './contact';
import { Customer } from './customer.model';

export interface Vehicle {
    id: string | null;
    tenantId: string;
    state: string;
    licensePlate: string;
    make: string;
    model: string;
    vin: string;
    year: number;
    createdDate?: string;
    createdBy?: string;
    mileage?: number;
    /** Next scheduled service. Written by a NextServiceDate-bound inspection item on transfer. */
    nextServiceDate?: string | null;
    notes?: string;
    subModel?: string;
    vehicleNumber?: string;
    customers?: Customer[];
    customerPrimaryContact?: Contact;
}

export interface VehicleHistory {
    quoteNumber?: string;
    date?: Date;
    odometer?: string;
    services?: VehicleServiceItem[];
    type?: string;
}

export interface VehicleServiceItem {
    name: string;
    status: string;
    parts: string;
    labor: string;
    notes?: string[];
    sectionName?: string;
    /** Distinguishes priced work from a technician remark recorded alongside it. */
    kind?: VehicleServiceItemKind;
}

export enum VehicleServiceItemKind {
    Service = 'Service',
    Note = 'Note',
}

export enum HistoryType {
    National = 'national',
    Invoice = 'invoice',
    Declined = 'declined',
}

/**
 * One measured value within a specification: a discrete value, or a min/max range, with the unit
 * label the provider used. Rendered verbatim; never normalised.
 */
export interface VehicleSpecItem {
    value?: string | null;
    minValue?: string | null;
    maxValue?: string | null;
    unitOfMeasure?: string | null;
    notes?: string[];
    /** Server-computed: false when the figure has no unit and must not be shown. */
    isDisplayable: boolean;
}

/** A vehicle-context attribute qualifying a specification, e.g. "Engine: 4.0L V6". */
export interface VehicleSpecAttribute {
    name: string;
    text: string;
}

/** A specification category ("content silo"), e.g. "Brake Specifications". */
export interface VehicleSpecCategory {
    id: number;
    name: string;
}

/** A single read-only specification within a category. */
export interface VehicleSpecification {
    applicationId?: number;
    categoryId: number;
    categoryName?: string | null;
    name: string;
    description?: string | null;
    position?: string | null;
    notes?: string[];
    items?: VehicleSpecItem[];
    attributes?: VehicleSpecAttribute[];
    procedures?: string[];
    providerType?: string | null;
}

/**
 * Names the DVI safety strip looks for. Kept here so the four apps match one list rather than each
 * hard-coding its own, and so a provider rename breaks in one place.
 */
export const VEHICLE_SPEC_ALTERNATE_SIZE_CATEGORY = "Alternate Sizes";

export const VEHICLE_SPEC_NAMES = {
    frontPressure: "Front Inflation Pressure",
    rearPressure: "Rear Inflation Pressure",
    wheelNutTorque: "Wheel Nut Torque",
} as const;

